export default [
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/fbh/fbh_1.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/fbh/fbh_2.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/fbh/fbh_3.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/fbh/fbh_4.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/fbh/fbh_5.jpeg"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/fbh/fbh_6.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/fbh/fbh_7.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/fbh/fbh_8.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/fbh/fbh_9.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/fbh/fbh_10.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/fbh/fbh_11.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/fbh/fbh_12.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/fbh/fbh_13.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/fbh/fbh_14.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/fbh/fbh_15.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/fbh/fbh_16.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/fbh/fbh_17.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/fbh/fbh_18.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/fbh/fbh_19.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/fbh/fbh_20.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/fbh/fbh_21.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/fbh/fbh_22.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/fbh/fbh_23.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/fbh/fbh_24.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/fbh/fbh_25.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/fbh/fbh_26.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/fbh/fbh_27.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/fbh/fbh_28.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/fbh/fbh_29.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/fbh/fbh_30.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/fbh/fbh_31.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/fbh/fbh_32.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/fbh/fbh_33.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/fbh/fbh_34.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/fbh/fbh_35.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/fbh/fbh_36.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/fbh/fbh_37.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/fbh/fbh_38.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_1.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_2.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_3.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_4.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_5.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_6.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_7.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_8.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_9.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_10.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_11.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_12.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_13.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_14.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_15.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_16.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_17.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_18.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_19.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_20.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_21.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_22.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_23.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_24.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_25.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_26.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_27.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_28.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_29.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_30.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_31.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_32.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_33.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_34.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_35.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_36.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_37.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_38.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_39.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_40.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_41.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_42.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_43.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_44.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_45.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_46.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_47.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_48.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_49.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_50.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_51.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_52.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_53.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_54.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_55.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_56.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_57.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_58.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_59.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_60.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_61.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_62.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_63.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_64.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_65.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_66.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_67.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_68.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_69.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_70.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_71.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_72.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_73.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_74.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_75.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_76.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_77.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_78.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_79.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_80.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_81.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_82.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_83.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_84.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_85.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_86.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_87.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_88.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_89.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_90.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_91.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_92.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_92.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_93.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_94.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_95.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_96.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_97.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_98.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_99.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_100.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_101.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_102.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_103.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_104.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_105.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_106.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_107.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_108.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_109.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_110.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_111.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/qc/QC_112.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/lbj/lbj_1.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/lbj/lbj_2.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/lbj/lbj_3.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/lbj/lbj_4.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/lbj/lbj_5.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/lbj/lbj_6.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/lbj/lbj_7.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/lbj/lbj_8.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/lbj/lbj_9.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/lbj/lbj_10.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/lbj/lbj_11.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/mt/MT_1.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/mt/MT_1.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/mt/MT_2.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/mt/MT_3.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/mt/MT_4.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/mt/MT_5.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/mt/MT_6.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/mt/MT_7.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/mt/MT_8.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/mt/MT_9.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/mt/MT_10.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/mt/MT_11.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/mt/MT_12.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/mt/MT_13.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/mt/MT_14.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/mt/MT_15.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/mt/MT_16.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/mt/MT_17.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/mt/MT_18.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/mt/MT_19.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/mt/MT_20.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/mt/MT_21.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/mt/MT_22.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/mt/MT_23.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/mt/MT_24.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/mt/MT_25.JPG"
    },
    {
        "img":"https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/22jie/mt/MT_26.JPG"
    }
]


// WEBPACK FOOTER //
// ./src/pages/history/jie22.js